// Safari fix - Clicking on the browser back button from the cart
// page should reload previously cached page (if it is bundles app)

(function () {
    window.onpageshow = function(event) {
    if (event.persisted) {
        window.location.reload();
    }
    };
})();
